module.exports = "/_next/static/images/e7aacdb5e63ba2ea318cb25edd6ecd43-chevron-left.svg.webp";